import React from 'react';
import PropTypes from 'prop-types';
import { createFragmentContainer, graphql } from 'react-relay';
import { Grid } from '@material-ui/core';
import { Icon } from '@hydra/common/components';
import get from 'lodash/get';

import DCUrl from '@hydra/routes/crawler/utils/DCUrl';
import DCUrlLabel from '@hydra/routes/crawler/components/DCUrlLabel';

export class DisallowedPagesRow extends React.Component {
  static propTypes = {
    issue: PropTypes.object,
    columnStyles: PropTypes.array,
    relay: PropTypes.object
  }

  render () {
    const {
      columnStyles,
      issue,
      className: classNameProp
    } = this.props;

    const domain = get(this.props, ['relay', 'route', 'params', 'url'], '');
    const issueUrl = new DCUrl(domain, issue.url);
    const sourceUrl = new DCUrl(domain, issue.source_url);

    return (
      <Grid container className={classNameProp} alignItems='flex-start'>
        <Grid item {...columnStyles[0]}>
          <DCUrlLabel className='truncate' url={issueUrl} severity={3} />
        </Grid>
        <Grid item {...columnStyles[1]}>
          <DCUrlLabel url={sourceUrl} severity={3} />
        </Grid>
        <Grid item {...columnStyles[2]}>
          {
            (issue.sitemap_url)
              ? <Icon type='check' color='success' size='sm' />
              : <Icon type='cross' color='error' size='sm' />
          }
        </Grid>
      </Grid>
    );
  }
}

export default createFragmentContainer(DisallowedPagesRow, {
  issue: graphql`
    fragment DisallowedPagesRow_issue on DisallowedPage {
      id
      type
      severity
      url
      source_url
      sitemap_url
    }
  `
});
